// Country Reducer
const countryDefaultState = {
    list : []
};

export default (state = countryDefaultState, action) => {
    switch (action.type) {
        case 'SET_COUNTRY':
            return {
                ...state,
                list: action.data
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/country.js